import React, { useState, useContext } from 'react';
import styles from './LoginForm.module.css';
import { FaUser, FaLock, FaEnvelope } from 'react-icons/fa'; // Import icons
import logo from '../assets/gmr-logo.jpg'; // Import the logo
import { AuthContext } from '../App';
import { useNavigate } from 'react-router-dom';
import { config } from '../config';  // This should be the dynamic config

interface LoginFormProps {
  onLogin: (username: string, password: string) => void;
  error: string | null;
}

const LoginForm: React.FC<LoginFormProps> = ({ onLogin, error }) => {
  const navigate = useNavigate();
  const { setIsAuthenticated, setAuthType } = useContext(AuthContext);
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [showAdminMessage, setShowAdminMessage] = useState(false);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    try {
      await onLogin(username, password);
      setIsAuthenticated(true);
      setAuthType('aws');
      sessionStorage.setItem('authType', 'aws');
      navigate('/dashboard');
    } catch (error) {
      console.error('Login error:', error);
    }
  };

  const handleForgotPassword = (e: React.MouseEvent) => {
    e.preventDefault();
    setShowAdminMessage(true);
  };

  return (
    <div className={styles.loginContainer}>
      <div className={styles.loginCard}>
        <div className={styles.loginForm}>
          <div className={styles.logoContainer}>
            <img src={logo} alt="Broker Management Portal Logo" className={styles.logo} />
          </div>
          <h1 className={styles.formTitle}>Welcome Back</h1>
          <p className={styles.formSubtitle}>Log in to your account</p>
          {error && <p className={styles.errorMessage}>{error}</p>}
          <form onSubmit={handleSubmit}>
            <div className={styles.inputGroup}>
              <div className={styles.inputWrapper}>
                <FaUser className={styles.inputIcon} />
                <input
                  type="text"
                  id="username"
                  value={username}
                  onChange={(e) => setUsername(e.target.value)}
                  required
                  placeholder="Username"
                />
              </div>
            </div>
            <div className={styles.inputGroup}>
              <div className={styles.inputWrapper}>
                <FaLock className={styles.inputIcon} />
                <input
                  type="password"
                  id="password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  required
                  placeholder="Password"
                />
              </div>
            </div>
            <button type="submit" className={styles.loginButton}>Sign In</button>
          </form>
          <p className={styles.forgotPassword}>
            <a href="#" onClick={handleForgotPassword}>Forgot password?</a>
          </p>
          {showAdminMessage && (
            <p className={styles.adminMessage}>
              <FaEnvelope className={styles.messageIcon} />
              Please contact your administrator for password reset assistance.
            </p>
          )}
        </div>
        <div className={styles.loginImage}>
          <h2>Broker Management Portal</h2>
          <p>Streamline your workflow and manage plans efficiently.</p>
        </div>
      </div>
    </div>
  );
};

export default LoginForm;